<div class="modal fade" :id="modalId" tabindex="-1" role="dialog" :aria-labelledby="modalId + 'Label'" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" :id="modalId + 'Label'">Contact Us</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onModalCloseClick">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form>
                    <div class="form-group">
                        <label>Query Type</label>
                        <bootstrap-select  :selectOptions="messageTypes" :selectedOption="selectedMessageType.messageTypeId" :elementId="'messageTypeSelect'"
                                           :returnSelectedOptionText="true"
                                           @changeSelect="onMessageTypeSelect"></bootstrap-select>
                    </div>
                    <div class="form-group">
                        <label>Message</label>
                        <div class="text-danger" v-if="message.hasError">
                            {{message.errorMessage}}
                        </div>
                        <textarea class="form-control" v-model="message.value" rows="5" placeholder="Message"></textarea>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-success" @click="sendQueryEmail" :disabled="loading">SAVE</button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="onModalCloseClick" :disabled="loading">CLOSE</button>
            </div>
        </div>
    </div>
</div>